import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import order from './modules/order'
import research from './modules/research'
import plan from './modules/plan'
import volunteer from './modules/volunteer'

import * as actions from './actions';
import * as getters from './getters';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    order,
    research,
    plan,
    volunteer
  },
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js